// Define default colors and settings for Highcharts
const psVHighchartsTheme = {
    accessibility: {
        enabled: true, // Enables the data table view
        announceNewData: {
            enabled: true,
        },
    },

    colors: ['#8dc63f', '#1c4d88'],

    chart: {
        backgroundColor: 'transparent',
        style: {
            fontFamily: 'Poppins, sans-serif',
        },
        events: {
            fullscreenOpen: function () {
                this.update({
                    chart: {
                        backgroundColor: 'var(--chakra-colors-background-primary)',
                    },
                });
            },
        },
    },

    csv: {
        dateFormat: '%Y-%m-%d',
        itemDelimiter: ',',
        lineDelimiter: '\n',
    },

    title: {
        style: {
            color: 'var(--chakra-colors-text-primary)',
            fontWeight: '500',
        },
    },

    subtitle: {
        style: {
            color: 'var(--chakra-colors-text-tertiary)',
        },
    },

    legend: {
        itemStyle: {
            color: 'var(--chakra-colors-text-primary)',
        },
        itemHoverStyle: {
            color: '#1c4d88',
        },
    },

    xAxis: {
        labels: {
            style: {
                color: 'var(--chakra-colors-text-tertiary)',
            },
            reserveSpace: true, // Ensure space is reserved for labels
            align: 'right', // Align text to the right
        },
        title: {
            style: {
                color: 'var(--chakra-colors-text-tertiary)',
            },
        },
        gridLineColor: 'var(--chakra-colors-border-primary)',
    },

    yAxis: {
        labels: {
            style: {
                color: 'var(--chakra-colors-text-tertiary)',
            },
            align: 'right', // Align text to the right
            reserveSpace: true, // Ensure space is reserved for labels
        },
        title: {
            style: {
                color: 'var(--chakra-colors-text-tertiary)',
            },
            rotation: 0, // Keep the title horizontal
        },
        gridLineColor: 'var(--chakra-colors-border-primary)',
        lineWidth: 1, // Add a line along the axis
        gridLineWidth: 1, // Add grid lines
        opposite: false, // false means left side (true would be right side)
    },

    plotOptions: {
        series: {
            animation: {
                duration: 500,
            },
            states: {
                hover: {
                    lineWidthPlus: 0,
                },
            },
        },
    },

    tooltip: {
        backgroundColor: 'var(--chakra-colors-background-tertiary)',
        borderColor: 'var(--chakra-colors-border-secondary)',
        style: {
            color: 'var(--chakra-colors-text-primary)',
        },
    },

    // Respect dark mode by dynamically applying colors based on the CSS variables
    credits: {
        style: {
            color: 'var(--chakra-colors-text-tertiary)',
        },
    },
};

export default psVHighchartsTheme;
